export default "__VITE_ASSET__8f63a6c8__"